import { Button } from '@repo/ui/components/button'
import { cn } from '@repo/ui/lib/utils'
import { MoveLeftIcon } from 'lucide-react'
import { ButtonHTMLAttributes, FunctionComponent } from 'react'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  direction: 'previous' | 'next'
  formAction: ButtonHTMLAttributes<HTMLButtonElement>['formAction']
}

const ProductMediaLightboxButton: FunctionComponent<Props> = ({ direction, formAction, ...rest }) => {
  return (
    <Button
      size='arrow'
      variant='navigationInverse'
      formAction={formAction}
      className={cn('fixed top-1/2 -translate-y-1/2', direction === 'previous' ? 'left-4 cursor-w-resize' : 'right-4 cursor-e-resize')}
      {...rest}
    >
      <MoveLeftIcon className={cn(direction === 'next' && 'rotate-180')} />
    </Button>
  )
}

export default ProductMediaLightboxButton
